var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"schemaBasicForm"},[_c('schema-form-common',{ref:"schemaForm",attrs:{"schemaData":_vm.schemaData,"schemaConfig":_vm.schemaConfig,"schemaRules":_vm.schemaRules,"schemaBasicInfo":_vm.schemaBasicInfo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }